import {Component, NgModule, OnInit} from '@angular/core';

const { version: appVersion } = require('../../../../package.json')
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  get version() {
    return appVersion;
  }
  constructor() { }

  ngOnInit() {
  }

}

@NgModule({
  exports: [FooterComponent],
  declarations: [FooterComponent],
})
export class FooterModule {}



// WEBPACK FOOTER //
// /Users/mengxin/Develop/WebProjects/xin-angular/src/app/layout/footer/footer.component.ts